const KEY = 'mytasklog_app_config';

/** 引き継ぎ用の文字列につける目印 */
const PREFIX = 'MTLCFG1:';

/** 入力してもらう項目 */
export const CONFIG_FIELDS = [
  {
    key: 'apiKey',
    label: 'apiKey',
    group: 'firebase',
    placeholder: 'AIzaSy...',
  },
  {
    key: 'authDomain',
    label: 'authDomain',
    group: 'firebase',
    placeholder: 'your-project.firebaseapp.com',
  },
  {
    key: 'projectId',
    label: 'projectId',
    group: 'firebase',
    placeholder: 'your-project',
  },
  {
    key: 'storageBucket',
    label: 'storageBucket',
    group: 'firebase',
    placeholder: 'your-project.firebasestorage.app',
  },
  {
    key: 'messagingSenderId',
    label: 'messagingSenderId',
    group: 'firebase',
    placeholder: '1234567890',
  },
  {
    key: 'appId',
    label: 'appId',
    group: 'firebase',
    placeholder: '1:1234567890:web:abcdef',
  },
  {
    key: 'oauthClientId',
    label: 'OAuth Client ID',
    group: 'google',
    placeholder: '1234567890-xxxx.apps.googleusercontent.com',
  },
];

export const getConfig = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || null;
  } catch {
    return null;
  }
};

/** すべての項目が埋まっているか */
export const hasConfig = () => {
  const c = getConfig();
  if (!c) return false;
  return CONFIG_FIELDS.every((f) => typeof c[f.key] === 'string' && c[f.key].trim() !== '');
};

export const saveConfig = (config) => {
  const trimmed = {};
  CONFIG_FIELDS.forEach((f) => {
    trimmed[f.key] = (config[f.key] || '').trim();
  });
  localStorage.setItem(KEY, JSON.stringify(trimmed));
};

export const clearConfig = () => localStorage.removeItem(KEY);

/** Firebase に渡す形 */
export const getFirebaseConfig = () => {
  const c = getConfig();
  if (!c) return null;
  return {
    apiKey: c.apiKey,
    authDomain: c.authDomain,
    projectId: c.projectId,
    storageBucket: c.storageBucket,
    messagingSenderId: c.messagingSenderId,
    appId: c.appId,
  };
};

export const getGoogleClientId = () => {
  const c = getConfig();
  return c ? c.oauthClientId : '';
};

// ==========================================================
// 別の端末への引き継ぎ
// ==========================================================
// 7項目をまとめて1行にする。改行が入らないので、
// メモアプリなどを経由してそのまま貼り付けられる。

/** 日本語などが混ざっても壊れないようにする */
const toBase64 = (str) => {
  const bytes = new TextEncoder().encode(str);
  let bin = '';
  bytes.forEach((b) => {
    bin += String.fromCharCode(b);
  });
  return btoa(bin);
};

const fromBase64 = (b64) => {
  const bin = atob(b64);
  const bytes = Uint8Array.from(bin, (ch) => ch.charCodeAt(0));
  return new TextDecoder().decode(bytes);
};

/** 現在の設定を1行の文字列にする */
export const exportConfigString = (config) => {
  const src = config || getConfig();
  if (!src) return '';
  const picked = {};
  CONFIG_FIELDS.forEach((f) => {
    picked[f.key] = (src[f.key] || '').trim();
  });
  return PREFIX + toBase64(JSON.stringify(picked));
};

/**
 * 貼り付けられた文字列を読み取る。
 * 引き継ぎ用の文字列のほか、Firebaseコンソールが出す
 * firebaseConfig の記述をそのまま貼っても読み取れるようにしてある。
 *
 * @returns { values, error }
 */
export const parseConfigString = (text) => {
  const raw = (text || '').trim();
  if (!raw) return { values: null, error: '貼り付ける内容がありません' };

  // 1. 引き継ぎ用の文字列
  if (raw.startsWith(PREFIX)) {
    try {
      const obj = JSON.parse(fromBase64(raw.slice(PREFIX.length)));
      const values = {};
      CONFIG_FIELDS.forEach((f) => {
        values[f.key] = typeof obj[f.key] === 'string' ? obj[f.key] : '';
      });
      return { values, error: '' };
    } catch {
      return { values: null, error: '引き継ぎ用の文字列が壊れています' };
    }
  }

  // 2. JSON もしくは firebaseConfig の記述
  const values = {};
  let found = 0;

  CONFIG_FIELDS.forEach((f) => {
    // apiKey: "xxx" / "apiKey": 'xxx' のどちらも拾う
    const re = new RegExp(`["']?${f.key}["']?\\s*[:=]\\s*["']([^"']+)["']`, 'i');
    const m = raw.match(re);
    if (m) {
      values[f.key] = m[1];
      found += 1;
    } else {
      values[f.key] = '';
    }
  });

  if (found === 0) {
    return { values: null, error: '読み取れる項目がありませんでした' };
  }

  return { values, error: '' };
};
